<template>
  <div>
    
    <top-navbar />
<!-- <pre>{{ results }}</pre> -->
    

    <div class="mb-5 " >

      <h6 class="manage-boder pt-2 font1 decoration" >
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3">
          <i class="fa fa-angle-right"></i>
        </span>
        <span class="decoration">CAMO</span>
        <span class="pfimg3">
          <i class="fa fa-angle-right"></i>
        </span>
        Show Saved Data
      </h6>

      <div class="container-fluid" style="padding-bottom: 10px;">
        <div class=" bdr-rad2 mt-1  p-2" >
          <div class="" >

            <!-- SEARCH -->
            <div class="search-container ">
<div class="card" style="padding: 3px;">
<div class="" v-if="pdfButtons.length">
  <div
    v-for="btn in pdfButtons"
    :key="btn.id"
    class="btn btn-sm btn-primary bdr-rad ms-1"
    :class="{ active: String(id) === String(btn.id) }"
    @click="openPdfTab(btn.id)"
  >
    {{ btn.name }}
  </div>
</div>
</div>

<!-- <div v-if="isFilteredView" class="mb-3">
  <strong>{{ groupedTitle }}</strong>
</div> -->

              <!-- RESULTS -->
           <div v-if="!isLoading">
  <div
    v-for="(group, index) in groupedResults"
    :key="index"
    class="matched-table mt-3"
  >
 <div class="mb-2">
  <strong>{{ group.header_info.title }}</strong><br>
  LN: {{ getDisplayLn(group.header_info) }}<br>
  CVN: {{ getDisplayCvn(group.header_info) }}<br>
  MSN: {{ getDisplayMsn(group.header_info) }}<br>
  Reg: {{ getDisplayReg(group.header_info) }}<br>
 {{ group.file || '-' }} - Page {{ group.page || '-' }}

</div>
    <div class="table-responsive">
    <table
      class="table table-hover table-sm table-borderless mt-2 table-responsive"
      style="font-size: small;"
    >
      <!-- TABLE HEADER (ONLY ONCE) -->
      <thead class="background_color2">
        <tr class="custom-label2">
            <th>Select</th>
          <th
            v-for="(h, j) in group.table_header"
            :key="j"
          >
            {{ h }}
          </th>
           <th>Task Card</th>
            <th>Ref:</th>
             <th>Task Date</th>
        </tr>
      </thead>

      <!-- MULTIPLE ROWS -->
     <tbody>
  <tr
    v-for="(row, rIndex) in group.rows"
    :key="rIndex"
  >
   <td>
      <input
  type="checkbox"
  v-model="selectedRows"
  :value="{
    file: group.file,
    page: group.page,
    headers: group.table_header,
    row: row,
    header_info: group.header_info || {}
  }"
/>
    </td>
<td v-for="(header, cIndex) in group.table_header" :key="cIndex">
  {{ row.data[cIndex] }}
</td>

<td>
  <input v-show="row.task_file_url==''"  type="file" @change="handleFileUpload($event, row.id)" class="form-control bdr-rad chose-font" />

   <a
  v-if="row.task_file_url && row.task_file_url.trim() !== ''"
  :href="`/${row.task_file_url}`"
  target="_blank"
  class="d-flex align-items-center"
>
 
   <img
        style="padding-left: 5px"
        src="../../../public/img/pdf_logo_medium.png"
        width="35px"
        alt="Evenware Logo"
      />
</a>

</td>

<td> {{ row.ref_no || '-' }} </td>
<td> {{ row.task_date || '-' }}</td>


  </tr>
</tbody>

    </table>
    </div>
  </div>
<button
  class="btn  mt-3"
  @click="generateExcel"
   style="cursor: pointer;"
  :disabled="!selectedRows.length"
>
<img
      
     
      src="../../../public/img/excel.png"
      width="52px"
      alt="Evenware Logo"
    />
</button>

  <p v-if="searched && !groupedResults.length" class="mt-3">
    No results found.
  </p>
</div>
            </div>

          </div>
        
<div v-if="showPopup" class="popup-overlay">
  <div class="popup-card">
    <!-- Fixed Header -->
    <!-- <div class="popup-header">
      <h5>Crop area to extract text</h5>  
    </div> -->

    <!-- Scrollable Content -->
    <div class="popup-body">
      <!-- Show OCR editable box if result exists -->
      

      <!-- PDF Canvas -->
      <canvas v-show="!ocrText"
        ref="pdfCanvas"
        @mousedown="startSelection"
        @mousemove="drawSelection"
        @mouseup="endSelection"></canvas>
    </div>

    <!-- Fixed Footer -->
   <div class="popup-footer ">
  <!-- OCR Result input (left side) -->
   <div v-if="ocr_ref" class="mb-1">
      <!-- <label class="mb-1">OCR Result (editable):</label>
      <input type="text" v-model="ocrText" class="form-control" /> -->
      <label class="mb-1">Ref:</label>
      <input type="text" v-model="ocr_ref" class="form-control" disabled/>
      <label class="mb-1">Authorised Date</label>
      <input type="text" v-model="ocr_auth_date" class="form-control" />
    </div>

  <!-- Buttons (right side) -->
            <div class="d-flex justify-content-center mt-3" v-if="isLoading2">
                <div class="spinner-border text-primary">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
              
  <div v-if="!isLoading2" class="">
    <button class="btn btn-sm btn-secondary mr-1" @click="closePopup">Cancel</button>
    <button v-if="!ocr_ref" class="btn btn-sm btn-primary" @click="runOcr">Save</button>
    <button v-if="ocr_ref" class="btn btn-sm btn-success " @click="confirmOcr">Confirm</button>
  </div>
</div>

  </div>
</div>
      
         
        </div>
            
      </div>
  
    </div>
   <br>

    <content-footer />
    
  </div>
</template>

<script>
import axios from "axios";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";

export default {
  data() {
    return {
      id: this.$route.query.id,
      aircraft: this.$route.query.aircraft || "",
      line: this.$route.query.line || "",
      group: this.$route.query.group || "",
      filterFile: this.$route.query.file || "",
      results: [],
      selectedRows: [],
      showPopup:false,
      isLoading: false,
      isLoading2: false,
      searched: false,
      showSavePopup: false,
      pdfButtons: [],
        ocrText: "",
       ocr_auth_date: "",
      ocr_ref: "",
    };
  },

   mounted(){
    this.loadPageData();
      },
 computed: {
 isFilteredView() {
  return !!(this.aircraft || this.line || this.filterFile || this.group === 'other');
 },
  groupedTitle() {
  if (!this.isFilteredView) {
    return "";
  }

  if (this.group === 'other') {
    if (this.filterFile) {
      return `Other | File: ${this.filterFile}`;
    }

    if (this.line) {
      return `Other | Line: ${this.line}`;
    }

    return 'Other';
  }

  if (this.aircraft && this.line) {
    return `Aircraft: ${this.aircraft} | Line: ${this.line}`;
  }

  if (this.aircraft) {
    return `Aircraft: ${this.aircraft}`;
  }

  if (this.line) {
    return `Line: ${this.line}`;
  }

  return "";
 },
 groupedResults() {

  const map = {};

  this.results.forEach((r) => {

    const page = r.page || r.sheet || "";   // ✅ safe fallback

    const key = `${r.file}_${page}`;

    if (!map[key]) {
      map[key] = {
        file: r.file || "",
        page: page,
        table_header: r.table_header || [],
        header_info: r.header_info || {},
        rows: [],
      };
    }

   if (r.matched_row && Array.isArray(r.matched_row)) {
  r.matched_row.forEach(item => {
    map[key].rows.push({
      data: item.row_data,
      task_date: item.task_date,
      task_file_url: item.task_file_url,
      ref_no: item.ref_no,
      id: item.id
    });
  });
}

  });

  return Object.values(map);

},

},

watch: {
  '$route.query': {
    handler() {
      this.id = this.$route.query.id;
      this.aircraft = this.$route.query.aircraft || "";
      this.line = this.$route.query.line || "";
      this.group = this.$route.query.group || "";
      this.filterFile = this.$route.query.file || "";
      this.selectedRows = [];
      this.loadPageData();
    },
    deep: true
  }
},

 components :{
          
            ContentFooter,
            TopNavbar,
           
        },



  methods: {
    sanitizeHeaderValue(value, removeLabels = []) {
      let cleaned = (value || "").toString().trim();

      removeLabels.forEach((label) => {
        const regex = new RegExp(`\\s*${label}\\s*:?\\s*.*$`, "i");
        cleaned = cleaned.replace(regex, "");
      });

      cleaned = cleaned.trim();
      return cleaned || "-";
    },

    getDisplayLn(headerInfo = {}) {
      const lnValue = headerInfo.ln || headerInfo.line_number || "";
      return this.sanitizeHeaderValue(lnValue, ["MSN", "CVN", "Reg"]);
    },

    getDisplayMsn(headerInfo = {}) {
      const explicitMsn = this.sanitizeHeaderValue(headerInfo.msn || "", ["CVN", "Reg"]);
      if (explicitMsn !== "-") {
        return explicitMsn.replace(/^-+/, "").trim() || "-";
      }

      const lineValue = (headerInfo.ln || headerInfo.line_number || "").toString();
      const match = lineValue.match(/MSN\s*:?\s*([A-Z0-9-]+)/i);
      return match ? match[1].replace(/^-+/, "").trim() : "-";
    },

    getDisplayCvn(headerInfo = {}) {
      return this.sanitizeHeaderValue(headerInfo.cvn || headerInfo.airplane_id || "", ["MSN", "Reg"]);
    },

    getDisplayReg(headerInfo = {}) {
      return this.sanitizeHeaderValue(headerInfo.reg || "", ["MSN", "CVN"]);
    },


    handleFileUpload(event, tbl_id) {
  
      this.file = event.target.files[0];
      
      this.tbl_id = tbl_id;

      this.SaveProduct2();
    },

    async SaveProduct2() {
      console.log(this.file)
      console.log(this.tbl_id);
   
      if (!this.file) {
        alert("Please select a file first.");
        return;
      }

      if (this.file.type.includes("pdf")) {
        this.showPopup = true;
        await this.renderPDF(this.file);
      } else {
        alert("Only PDF supported for crop OCR here.");
      }
    },

    async renderPDF(file) {
  const reader = new FileReader();

  reader.onload = async (e) => {
    const typedarray = new Uint8Array(e.target.result);
    const pdf = await window.pdfjsLib.getDocument({ data: typedarray }).promise;

    const popupBody = this.$el.querySelector(".popup-body");
    popupBody.innerHTML = "";

    // limit to 10 pages OR total pages
    const totalPages = Math.min(pdf.numPages, 5);

    for (let i = 1; i <= totalPages; i++) {
      const page = await pdf.getPage(i);
      const viewport = page.getViewport({ scale: 2 });

      const canvas = document.createElement("canvas");
      canvas.width = viewport.width;
      canvas.height = viewport.height;
      canvas.style.border = "1px solid #ccc";
      canvas.style.marginBottom = "10px";

      const ctx = canvas.getContext("2d");

      await page.render({
        canvasContext: ctx,
        viewport: viewport,
      }).promise;

      popupBody.appendChild(canvas);

      // keep FIRST page reference (no change to your OCR code)
      if (i === 1) {
        this.firstPageCanvas = canvas;
      }
    }
  };

  reader.readAsArrayBuffer(file);
},


   startSelection(e, canvas, bufferCanvas) {
      this.isSelecting = true;
      const rect = canvas.getBoundingClientRect();
      this.selection = {
        canvas,
        bufferCanvas,
        x: e.clientX - rect.left,
        y: e.clientY - rect.top,
        w: 0,
        h: 0,
      };
    },

    drawSelection(e, canvas, bufferCanvas) {
      if (!this.isSelecting || !this.selection) return;
      const rect = canvas.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      this.selection.w = x - this.selection.x;
      this.selection.h = y - this.selection.y;

      // redraw from buffer
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(bufferCanvas, 0, 0);

      // draw selection rectangle
      ctx.save();
      ctx.strokeStyle = "red";
      ctx.lineWidth = 2;
      ctx.setLineDash([6]);
      // draw rect with support for negative w/h (dragging left/up)
      const sx = this.selection.w < 0 ? this.selection.x + this.selection.w : this.selection.x;
      const sy = this.selection.h < 0 ? this.selection.y + this.selection.h : this.selection.y;
      const sw = Math.abs(this.selection.w);
      const sh = Math.abs(this.selection.h);
      ctx.strokeRect(sx, sy, sw, sh);
      ctx.restore();
    },

     endSelection(e, canvas, bufferCanvas) {
      if (!this.selection) return;
      this.isSelecting = false;

      // normalize selection coordinates (so width/height are positive)
      let { x, y, w, h } = this.selection;
      const sx = w < 0 ? x + w : x;
      const sy = h < 0 ? y + h : y;
      const sw = Math.abs(w);
      const sh = Math.abs(h);

      // small area guard
      if (sw < 5 || sh < 5) {
        this.selection = null;
        // redraw full page without box
        const ctx = canvas.getContext("2d");
        ctx.drawImage(bufferCanvas, 0, 0);
        return;
      }

      this.selection = { canvas, bufferCanvas, x: sx, y: sy, w: sw, h: sh };

      // final draw of rectangle
      const ctx = canvas.getContext("2d");
      ctx.drawImage(bufferCanvas, 0, 0);
      ctx.save();
      ctx.strokeStyle = "red";
      ctx.lineWidth = 2;
      ctx.setLineDash([6]);
      ctx.strokeRect(sx, sy, sw, sh);
      ctx.restore();
    },

async runOcr() {
  if (!this.file) {
    alert("Please upload a PDF");
    return;
  }

  this.isLoading2 = true;

  let formData = new FormData();
  formData.append("file", this.file); // ✅ send PDF

  try {
    const response = await axios.post(
      "/mproduct/scan",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    this.isLoading2 = false;

    console.log(response.data);

    this.ocr_ref = response.data.ocr_ref || "";
    this.ocr_auth_date = response.data.ocr_auth_date || "";

  } catch (error) {
    this.isLoading2 = false;
    alert(error.message);
  }
},



    async confirmOcr() {
  this.isLoading2 = true;
  const formData2 = new FormData();
  formData2.append("task_file", this.file);
  formData2.append("tbl_id", this.tbl_id);

  formData2.append("id", this.id);

  // ✅ SEND OCR VALUES DIRECTLY
  formData2.append("date", this.ocr_auth_date);
  formData2.append("ref", this.ocr_ref);

  try {
    const { data } = await axios.post(
      "/mproduct/updatedate2",
      formData2
    );

    console.log(data);

    if (data.status == 200) {
       this.isLoading2 = false;
     // this.loadById(this.id);   // reload data
      window.location.reload();
    }

  } catch (error) {
    console.log(error.response);
  }

  this.showPopup = false;
  this.ocrText = "";
},

    closePopup() {
      this.showPopup = false;
      this.selection = null;
      this.ocrText = "";
    },

      async openPdfTab(id){
        if (this.isFilteredView) {
          this.$router.push({
            path: '/pdf/index2',
            query: {
              aircraft: this.aircraft,
              line: this.line,
              group: this.group || undefined,
              file: this.filterFile || undefined,
              id: id
            }
          });
          return;
        }

        this.$router.push('/pdf/index2?id='+id);
      },

loadPageData() {
  if (this.isFilteredView) {
    this.loadFilteredTabs();
    return;
  }

  this.loadById(this.id);
  this.loadPdfButtons();
},

loadPdfButtons() {
  axios.get("/mproduct/getpdfnamesavelist")
    .then(res => {
      if (res.data.success) {
        this.pdfButtons = res.data.data;
      }
    })
    .catch(err => {
      console.error(err);
    });
},

loadFilteredTabs() {
  this.isLoading = true;
  this.results = [];

  axios.get("/mproduct/getmaintenancetabs", {
    params: {
      aircraft: this.aircraft,
      line: this.line,
      group: this.group || undefined,
      file: this.filterFile || undefined
    }
  })
    .then(res => {
      if (res.data.success) {
        this.pdfButtons = res.data.data || [];

        if (!this.pdfButtons.length) {
          this.results = [];
          this.searched = true;
          this.isLoading = false;
          return;
        }

        const activeId = this.id || this.pdfButtons[0].id;

        if (String(this.id || '') !== String(activeId)) {
          this.$router.replace({
            path: '/pdf/index2',
            query: {
              aircraft: this.aircraft,
              line: this.line,
              group: this.group || undefined,
              file: this.filterFile || undefined,
              id: activeId
            }
          });
          return;
        }

        this.loadById(activeId);
        return;
      }

      this.isLoading = false;
    })
    .catch(err => {
      console.error(err);
      this.isLoading = false;
    });
},


loadById(id) {
  console.log('testloadbyid');
  
  this.isLoading = true; // start loading
 this.results = [];
  axios.get(`/mproduct/getmaintenancebyid?id=${id}`, {
    params: {
      aircraft: this.aircraft || undefined,
      line: this.line || undefined,
      group: this.group || undefined,
      file: this.filterFile || undefined
    }
  })
    .then(res => {
      console.log(res);
  this.results = res.data.data;
      if (res.data.success) {
        this.results = res.data.data;
        this.searched = true;
      }
    })
    .catch(err => {
      console.error(err);
    })
    .finally(() => {
      this.isLoading = false; // ✅ stop loading
    });
},


 

generateExcel() {
  if (!this.selectedRows.length) {
    alert("Select rows first");
    return;
  }

  const groups = {};

  // GROUP DATA BY FILE + PAGE
  this.selectedRows.forEach(item => {
    const key = item.file + "_" + item.page;

    if (!groups[key]) {
      groups[key] = {
        file: item.file,
        page: item.page,
        headers: item.headers,
        header_info: item.header_info || {},
        rows: []
      };
    }

    groups[key].rows.push(item.row);
  });

  const excelData = [];
  const headerRowIndexes = []; // store indexes of table headers for styling

  Object.values(groups).forEach(group => {
    const info = group.header_info;

    // 1️⃣ Header info rows (Title, Line, Aircraft, File)
    excelData.push([`Title: ${info.title || '-'}`]);
    excelData.push([`Line: ${info.line_number || '-'}`]);
    excelData.push([`Aircraft: ${info.airplane_id || '-'}`]);
    excelData.push([`File: ${group.file || '-'} - Page ${group.page || '-'}`]);
    excelData.push([]); // empty row before table

    // 2️⃣ Table headers
    headerRowIndexes.push(excelData.length); // save index BEFORE pushing
    excelData.push(group.headers);

    // 3️⃣ Table rows
    group.rows.forEach(row => {
  const rowData = group.headers.map((header, index) => {
    if (row && row.data) {
      return row.data[index] || ""; // Use row.data
    }
    return "";
  });
  excelData.push(rowData);
});

    // 4️⃣ Empty rows between tables
    excelData.push([]);
    excelData.push([]);
  });

  // CREATE WORKSHEET
  const worksheet = XLSX.utils.aoa_to_sheet(excelData);

  // =============================
  // HEADER STYLE APPLY
  // =============================
  headerRowIndexes.forEach(rowIndex => {
    const headers = excelData[rowIndex];
    headers.forEach((h, colIndex) => {
      const cellAddress = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex });
      if (!worksheet[cellAddress]) return;

      worksheet[cellAddress].s = {
        font: { bold: true, color: { rgb: "FFFFFF" } },
        fill: { fgColor: { rgb: "828282" } },
        alignment: { horizontal: "center" }
      };
    });
  });

  // Style header info rows (bold)
  for (let r = 0; r < excelData.length; r++) {
    const row = excelData[r];
    if (
      row.length === 1 &&
      row[0] && // ✅ safe check
      (row[0].includes("Title:") ||
        row[0].includes("Line:") ||
        row[0].includes("Aircraft:") ||
        row[0].includes("File:"))
    ) {
      const cellAddress = XLSX.utils.encode_cell({ r, c: 0 });
      if (worksheet[cellAddress]) {
        worksheet[cellAddress].s = { font: { bold: true } };
      }
    }
  }

  // Column width auto (optional)
  worksheet["!cols"] = [{ wch: 30 }, { wch: 60 }, { wch: 25 }, { wch: 20 }];

  // CREATE WORKBOOK AND EXPORT
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Maintenance");

  const wbout = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
    cellStyles: true
  });

  const blob = new Blob([wbout], { type: "application/octet-stream" });
  saveAs(blob, "maintenance_results.xlsx");
},


  },
};
</script>

<style scoped>
.search-container {
  padding: 20px;
}



button {
  padding: 6px 12px;
  cursor: pointer;
}

vs__dropdown-toggle {
      border-radius: 10px !important;
    border-top-left-radius: 10px !important;
    border-top-right-radius: 10px !important;
    border-bottom-right-radius: 10px !important;

}

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.popup-card {
  background: #fff;
  width: 80%;
  max-height: 90%;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  overflow: hidden;
}
canvas {
  border: 1px solid #ccc;
  cursor: crosshair;
}

.popup-header {
  background: #f8f9fa;
  border-bottom: 1px solid #ddd;
  padding: 10px;
}


/* Scrollable middle section */
.popup-body {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
}

/* Fixed footer */
.popup-footer {
  background: #fff;
  border-top: 1px solid #ddd;
  padding: 10px;
  width: 500px;
  align-items: center;
  justify-content: space-between; /* OCR input left, buttons right */
}
.ocr-box {
  flex: 1;
  margin-right: 15px;
}
.chose-font {
 font-size: smaller !important;
}




.tab-menu {
  display: flex;
  border-bottom: 1px solid #dee2e6;
  padding-left: 5px;
}

.tab-item {
  padding: 8px 16px;
  cursor: pointer;
  font-weight: 500;
  background: transparent;
  border: 1px solid transparent;
  border-bottom: none;
  margin-right: 4px;
  color: #0d6efd;
  border-radius: 15px 15px 0 0 ;
}

.tab-item:hover {
  color: #0a58ca;
}

.tab-item.active {
  background: #fff;
  color: #495057;
  border: 1px solid #dee2e6;
  border-bottom: 1px solid #fff;

}
</style>
